export interface HomePageMainDataModel {
  ulid: string
  name: string
  description: string
  path: string
  created_at: string
  updated_at: string
  original_filename: string;
  file_url: string;
}

export interface HomePageModel {
  main: {
    data: HomePageMainDataModel[];
    total: number;
  };
  detail: {
    data: HomePageMainDataModel;
  };
}

export enum HomePageActionType {
  GetAllHomePage = "⌘➝Configure➝GetAllHomePage",
  GetDetailHomePage = "⌘➝Configure➝GetDetailHomePage",
}

export type HomePageAction =
  | {
      data: {
        data: HomePageMainDataModel[];
        total: number;
      };
      type: HomePageActionType.GetAllHomePage;
    }
  | {
      data: {
        data: HomePageMainDataModel;
      };
      type: HomePageActionType.GetDetailHomePage;
    };